import { container } from '@shared/common/dependency-injection/domain/container';
import { LoginModuleRoutes } from '@shared/feature/login/application/routes/login.module-routes';
import { LoginRouteName } from '@shared/feature/login/application/routes/login.route-name';

export const loginRoutes = new LoginModuleRoutes(container).getRoutes({
  overrides: [
    {
      routeName: LoginRouteName.Login,
      routeData: {
        // The shared login module defaults to /login. In the client app, public
        // routes must stay under /client so redirects keep a consistent base URL.
        path: '/client/login',
      },
    },
  ],
});
